// extracted by mini-css-extract-plugin
export default {"tooltip":"SocialCart_tooltip__GqdZM","itemsContainer":"SocialCart_itemsContainer__Cufjk"};